import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import styled from 'styled-components';

import store from '../../../store/store';
import { successLogin } from '../../../actions/AuthActions';

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const SubmitButton = styled(Button)`
  && {
    background-color: #132630;
    border: 1px solid #324b5a;
    color: #eef3f5;
    cursor: pointer;
  }

  &&.Mui-disabled {
    background-color: #0c171d;
    border-color: #263b47;
    color: #71808a;
    cursor: not-allowed;
    opacity: 0.65;
    pointer-events: auto;
  }
`;

export const AcknowledgeDialog = ({ open, onClose, username }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const { config, layout } = store.getState();
  const { ACKNOWLEDGE_INTERFACE: service } = config;

  const sendAcknowledgeInformed = async (value) => {
    setDisabled(true);

    const { StudyInstanceUID: studyInstanceUID } = layout.elements[0];
  const { gatewayId: gid } = service;
    const postData = { gid, email: value, studyInstanceUID };

    return axios.post(service.endpoint, postData);
  };

  const afterSubmit = (res) => {
    setDisabled(false);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    onClose();
    if (res.status >= 200 && res.status <= 226 && res.data) {
      window.open(res.data.redirectUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const closeDialog = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    onClose();
  };

  const onSubmit = () => {
    if (username) {
      sendAcknowledgeInformed(username)
        .then(afterSubmit)
        .catch(() => setDisabled(false));
      return;
    }

    if (!isValidEmail(email)) {
      setEmailError(true);
      setDisabled(false);
      return;
    }

    dispatch(successLogin(email));
    localStorage.setItem('user', JSON.stringify({ email }));
    sendAcknowledgeInformed(email)
      .then(afterSubmit)
      .catch(() => setDisabled(false));
  };

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      disableRestoreFocus
      aria-labelledby="acknowledge-dialog-title"
      maxWidth={false}
      PaperProps={{
        style: {
          width: 500,
          maxWidth: 'calc(100% - 24px)',
          minHeight: 150,
          left: '50%',
          margin: 0,
          position: 'fixed',
          top: 75,
          transform: 'translate(-50%, 0)',
          fontSize: '1.3175rem',
          textAlign: 'center',
          color: '#dfe5ea',
          backgroundColor: '#111C',
          border: '1px solid #9FA5AABF',
        },
      }}
    >
      <DialogContent id="acknowledge-dialog-title" style={{ whiteSpace: 'pre-line' }}>
        {t('acknowledge.study', { username })}
        {!username && (
          <input
            type="email"
            value={email}
            required
            aria-invalid={emailError}
            aria-describedby={emailError ? 'acknowledge-email-error' : undefined}
            onChange={(event) => {
              setEmail(event.target.value);
              setEmailError(false);
            }}
            placeholder={t('enter.user.email')}
            style={{
              border: emailError ? '1px solid #d32f2f' : undefined,
              boxSizing: 'border-box',
              display: 'block',
              margin: '8px auto',
              maxWidth: '100%',
              padding: '4px 10px',
              width: 400,
            }}
          />
        )}
        {!username && emailError && (
          <div id="acknowledge-email-error" style={{ color: '#f28b82', fontSize: '0.85rem' }}>
            {t('invalid.email')}
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <SubmitButton
          variant="outlined"
          disabled={disabled}
          onClick={onSubmit}
        >
          {t('send')}
        </SubmitButton>
      </DialogActions>
    </Dialog>
  );
};

export default AcknowledgeDialog;
